module.exports = __webpack_public_path__ + "img/2.337f65ec.png";